// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jv_a bhu_a bhu_j bhu_q bhu_rp bhu_rq bhu_w"};